import { css, Theme } from "@emotion/react";

export const PromotionDetailStyle = {
  self: css`
    /*  */
  `,

  content: css`
    padding: 20px;
    /* max-height: calc(100vh - 100px);
    overflow: auto; */

    table {
      width: calc(100%) !important;
      margin: 0 !important;
    }
  `,

  btnSubscribe: ({ colors }: Theme) => css`
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 32px;
    button {
      width: 100px;
      height: 36px;
      color: ${colors.white};
      background-color: #2d7699;
      font-size: 14px;
      font-weight: 500;
      &:hover {
        color: ${colors.white} !important;
        background-color: #2d7699 !important;
      }
    }
  `,
};
